import { render } from "./Landing.vue?vue&type=template&id=856bb2e2&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=856bb2e2&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-856bb2e2"]])

export default __exports__